import React, { Component } from "react";

class Navigation extends Component {
  render() {
    return (
      <nav className="rail" aria-label="Sections">
        <button
          className="rail-btn"
          onClick={() => this.props.onChangePanel("home")}
        >
          <i className="bi bi-house"></i>
          <span className="rail-tip " data-en="Home" data-fa="خانه">
            Home
          </span>
        </button>

        <button
          className="rail-btn"
          onClick={() => this.props.onChangePanel("about")}
        >
          <i className="bi bi-person"></i>
          <span className="rail-tip" data-en="About" data-fa="درباره">
            About
          </span>
        </button>

        <button
          className="rail-btn"
          onClick={() => this.props.onChangePanel("resume")}
        >
          <i className="bi bi-mortarboard"></i>
          <span className="rail-tip" data-en="Resume" data-fa="رزومه">
            Resume
          </span>
        </button>

        <button
          className="rail-btn"
          onClick={() => this.props.onChangePanel("portfolio")}
        >
          <i className="bi bi-briefcase"></i>
          <span className="rail-tip" data-en="Portfolio" data-fa="نمونه‌کار">
            Portfolio
          </span>
        </button>

        <button
          className="rail-btn"
          onClick={() => this.props.onChangePanel("contact")}
        >
          {" "}
          <i className="bi bi-envelope"></i>
          <span className="rail-tip" data-en="Contact" data-fa="تماس">
            Contact
          </span>
        </button>
      </nav>
    );
  }
}

export default Navigation;
